module.exports = __webpack_public_path__ + "static/media/29.f79d0f0d.png";